let itemsData = [{
  "sku_id": 1000271,
  "title": "智能锁管理平台",
  "sub_title": "web端服务器",
  "ali_image": require('@/assets/img/products/software/platform/home.jpg'),
  "model": 'v1.3',
  "ali_images": [
    {'image':require('@/assets/img/products/software/platform/platform-home2.png')},
    {'image':require('@/assets/img/products/software/platform/platform-home1.png')},
    {'image':require('@/assets/img/products/software/platform/platform-openrecord.png')},
    {'image':require('@/assets/img/products/software/platform/platform-demo.png')},
    {'image':require('@/assets/img/products/software/platform/platform-demo2.png')},

  ],
  'tech':[
    '集多种功能于一体的综合性管理平台',
    '包括电脑web、微信小程序、手机APP、4G钥匙实时授权、实时推送和加密解密等功能模块',
    '电脑WEB可对区域、设备、账户等基础信息进行管理',  
    '可实时向浏览主页或微信公众号推送授权记录，开锁记录',
    '可查询各种操作记录',
    '可对电子钥匙进入添加、授权设置等操作',
  ]
  ,'pdf_url':'无源锁管理平台简介v1.3.pdf'
},{
  "sku_id": 1000299,
  "title": "微信小程序管理软件",
  "sub_title": "可以对蓝牙钥匙、指纹钥匙、远程4G钥匙进行管理",
  "ali_image": require('@/assets/img/products/software/wxMini/authDetail.jpg'),
  "model": 'v1.0.2',
  "ali_images": [
    {'image':require('@/assets/img/products/software/wxMini/authDetail.jpg')},
    {'image':require('@/assets/img/products/software/wxMini/authHistory.jpg')},
    {'image':require('@/assets/img/products/software/wxMini/remotekey.jpg')},
    {'image':require('@/assets/img/products/software/wxMini/home.jpg')},
    {'image':require('@/assets/img/products/software/wxMini/open_record.jpg')},
  ],
  'tech':[
    '登录服务器获取授权信息',
    '通过蓝牙对电子钥匙进行设置权限、上传开锁记录等操作',
    '可以安装设备、查询授权记录和开锁记录',
    '可以对指纹钥匙进行指纹录入和删除操作'
  ],
//'pdf_url':'led.pdf'
},
{
  "sku_id": 1000300,
  "title": "手机APP管理软件",
  "sub_title": "安卓版",
  "ali_image": require('@/assets/img/products/software/app/authkey.png'),
  "model": 'v1.3',
  "ali_images": [
    {'image':require('@/assets/img/products/software/app/authkey.jpg')},
    {'image':require('@/assets/img/products/software/app/authhistory.jpg')},
    {'image':require('@/assets/img/products/software/app/finger.jpg')},
    {'image':require('@/assets/img/products/software/app/home.jpg')},
    {'image':require('@/assets/img/products/software/app/install.jpg')},
  ],
  'tech':[
    '登录服务器获取授权信息',
    '通过蓝牙对电子钥匙进行设置权限、上传开锁记录等操作',
    '可以安装设备、查询授权记录和开锁记录',
    '可以对指纹钥匙进行指纹录入和删除操作'
  ]
  ,'pdf_url':''
},
{
  "sku_id": 1000302,
  "title": "微信公众号",
  "sub_title": "跨平台",
  "ali_image": require("@/assets/img/products/software/gongzonghao/openrecord.jpg"),
  "model": 'v1.0',
  "ali_images": [
    {'image':require("@/assets/img/products/software/gongzonghao/openrecord.jpg")},
//  {'image':require('@/assets/img/products/software/app/authhistory.jpg')},
//  {'image':require('@/assets/img/products/software/app/finger.jpg')},
//  {'image':require('@/assets/img/products/software/app/home.jpg')},
//  {'image':require('@/assets/img/products/software/app/install.jpg')},
  ],
  'tech':[
    '可实时接收开锁记录、授权记录',
    '可对基础信息进行管理',
    '可查询授权记录，开锁记录',
    '可对电子钥匙进行授权设置等操作'
  ],
  'pdf_url':''
}
]

export default itemsData



// WEBPACK FOOTER //
// ./src/lib/softwaresDetailData.js